import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/styles/agent-confirm-global.css'
import axios from 'axios'

// 导入统一的API配置
import { API_CONFIG } from './config/api'

axios.defaults.baseURL = API_CONFIG.API_BASE_URL
axios.defaults.headers.common['ngrok-skip-browser-warning'] = 'any'

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error),
)

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const path = error.config?.url || ''
      const isLoginFlow = /\/users\/(login|register)/.test(path)
      if (!isLoginFlow) {
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        const p = window.location.pathname
        if (p !== '/login' && p !== '/register') {
          window.location.href = '/login'
        }
      }
    }
    return Promise.reject(error)
  },
)

console.log(`API基础URL: ${axios.defaults.baseURL}`)

const app = createApp(App)

app.use(store)
app.use(router)
app.use(ElementPlus)

app.mount('#app') 